import React, { useEffect, useState } from "react";

import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import { getChatResponse,getChatHistoryResponse } from "./services/chatbot.service";
import { updateTheme } from "./helper/theme";
import isSvg from 'is-svg';
import { liveGageDarkTheme, liveGageTheme } from "./contexts/theme";




const ChatBot = (props) => {


  console.log('props ismobile..',props.isMobile,typeof(props.isMobile));
  // console.log('props.......123',props.appliedTheme.toString());
  // const navigate = useNavigate();  { domElement }
  const [toggle, setToggle] = useState(false);
  const [message, setMessage] = useState('');
  const [botmessage, setBotMessage] = useState([]);
  const [chatHistorymessage, setchatHistoryMessage] = useState([]);
  // const loanId = domElement.getAttribute("data-loanid");
  // const userId = domElement.getAttribute("data-userid");
  // const sender = domElement.getAttribute("data-sender");
  // const firstName = domElement.getAttribute("data-firstname");
  // const loginStatus = domElement.getAttribute("data-loginstatus");
  // const isLoggedIn = domElement.getAttribute("data-isloggedin");
  const themeName = props.domElement.getAttribute("data-themeName");
  const profile_url =  props.domElement.getAttribute("data-profile");
 
  // var theme = decodeURIComponent(props.domElement.getAttribute("data-theme"));;
 

  // window.onbeforeunload = function (event) {
  //   const newTabOpened = event.target === null;

  //   if (newTabOpened) {
  //     // New tab was opened
  //     console.log("New tab opened");
  //     // Perform desired actions
  //   }
  //   else{
  //     setToggle(false);
  //   }
  // };

  useEffect(()=>{
    try {
      var decodedObject = decodeURIComponent(props.domElement.getAttribute("data-theme"));
      const theme = JSON.parse(decodedObject); // Validate the JSON string
      console.log('themeData', theme);
      updateTheme(theme);
    } catch (error) {
      console.error("Invalid JSON string:", error);
    }

  },[themeName])

 






  const [chatId, setChatId] = useState('');
  const [timeDiff, setTimeDifference] = useState('');
  const MINUTE_MS = 1000;
  // let timer1 = setTimeout(() => setLoading(true), 1000)
  const [loading, setLoading] = useState(true);

  // let search = window.location.search;
  // let params = new URLSearchParams(search);
  // let  loan_id = params.get('loanId');

  // console.log('loanId chat bot ',loan_id)


  const text = 'Typing';
  const loader = `<div class="dots-message ">
        <span class="jumping-dots">
        ${text}
        <span class="dot-1"></span>
       <span class="dot-2"></span>
        <span class="dot-3"></span>
       </span>
     </div>`
  const botLoadingDelay = 1000
  const botReplyDelay = 2000;

  const [data, setData] = useState({
    userId: '',
    loanId: false,
    sender: '',
    isLoggedIn: false,
    loginStatus: 'logged out',
    firstName: ""
  })



  useEffect(() => {
    setData({
      userId: props.userid,
      loanId: props.loanid,
      sender: props.sender,
      isLoggedIn: props.isloggedin,
      firstName: props.firstname,
      loginStatus: props.loginstatus
    });

    if(props.isMobile == 'true'){
      setToggle(true);
      updateTheme(props.appliedTheme)
      

    }
   


  }, [props.loanid, props.sender, props.userid, props.isloggedin, props.firstname]);



  useEffect(() => {
    console.log('if condition', typeof (localStorage.getItem('linkClicked')), localStorage.getItem("linkClicked"))
    if ((Boolean(props.isloggedin) && props.loanid != undefined) && localStorage.getItem('linkClicked') == null) {
      console.log('props logged in....', props.isloggedin,localStorage.getItem("linkClicked"),localStorage.getItem("linkClicked")==null);
      // send('', false,true);
      send('/greet_initial', false, false);
    }
    if (localStorage.getItem('linkClicked') == 'true') {
      console.log('linkClicked', props.isloggedin,localStorage.getItem("linkClicked")=='true',localStorage.getItem("linkClicked")==null);
      setToggle(true);
      send('', false, true);
      localStorage.removeItem("linkClicked")

    }
  }, [props.isloggedin]);

  useEffect(() => {

    setTimeout(() => {
      botmessage?.map((value, index) => {
        console.log('value of', value, typeof (value))
        const hrefRegex = /href="([^"]*)"/;
        const match = value.text.match(hrefRegex);
      

        if (match) {
          const href1 = match[1];
          console.log('match',  href1);
          const anchorTag = document.querySelector(`a[href="${href1}"]`);
          anchorTag.removeAttribute('href');
          anchorTag.removeAttribute('target');
          anchorTag.style.color  = "#2175BB";
          console.log('anchorTag', anchorTag, href1);
          anchorTag.addEventListener('click', function (evt) {
            evt.preventDefault();
            
            anchorTag.setAttribute("href", "#");
          
            localStorage.setItem('linkClicked', "true");
           window.open(href1, "_blank");
            // window.open('http://localhost:3001/documents', "_blank");

          })
        }


        if (value.buttons && value.buttons.length > 0) {
          value.buttons.map((btn, i) => {
            var btns = document.querySelectorAll('#responsiveCard' + i);
            console.log('btns', btns);
            for (var i = 0; i < btns.length; i++) {
              btns[i].addEventListener('click', function (evt) {
                multiChoiceAnswer(btn.title, btn.payload, true, false);
                let div = document.getElementById('quick-replies-btn');
                div.remove('quick-replies-buttons');
                //  div.classList.add('hide-quick-replies-button');
              });

            }
          });
        }
      });

    }, botLoadingDelay + botReplyDelay + 100);
 }, [botmessage]);

  const handleChange = event => {
    setMessage(event.target.value);

  };



  const escapeScript = unsafe => {
    const safeString = unsafe
      .replace(/</g, ' ')
      .replace(/>/g, ' ')
      .replace(/&/g, ' ')
      .replace(/"/g, ' ')
      .replace(/\\/, ' ')
      .replace(/\s+/g, ' ')
    return safeString.trim()
  }

  const validateMessage = (txt) => {
    const text = txt;
    const safeText = text ? escapeScript(text) : ''
    console.log('inside if', safeText)
    if (safeText.length && safeText !== ' ') {
      console.log('inside if', safeText)
      setMessage(' ');
      userMessage(safeText)
      send(safeText, false, false)
    }
    return
  }


  const aiMessage = (content, isLoading = false, delay = 0) => {

    const $chatbotMessages = document.getElementById('chat-output');
    setTimeout(() => {
      removeLoader()
      $chatbotMessages.innerHTML += `
<div id='${isLoading ? "is-loading" : ""}'>
 ${content ?
          `<div class="caption"><div class="avatar">
<div data-status="loaded" data-cover="true" class="lazy-img">
<img src="/chat_bot.png" alt="" class="lazy-img-loaded">
</div></div> 
<span >
   Bot
</span>
</div> 
 ${content}
 </div>`: `<></>`}`
    }, delay);


  }

  const setResponse = (val, delay = 0) => {
    console.log(val);
    setTimeout(() => {
      aiMessage(processResponse(val))

    }, delay)
  }

  const setHistoryResponse = (val, delay = 0) => {
    console.log(val);
   processChatHistoryResponse(val)
  }

  const processChatHistoryResponse = (msg) => {
    const $chatbotMessages = document.getElementById('chat-output');
    var botMsg = '';
    var userMsg = '';
    // let btnHtml = '';
    // var buttonarray = [];
    msg?.map((value, index) => {
      // if (value.buttons) {
      //   buttonarray = value.buttons.length;
      // }


      if (value.text !== 'undefined' && value.text !== '') {
        
 
          $chatbotMessages.innerHTML += `${value.sender.toLowerCase() === 'bot' ? 
          `<div class="caption"><div class="avatar">
        <div data-status="loaded" data-cover="true" class="lazy-img">
        <img src="/chat_bot.png" alt="" class="lazy-img-loaded">
        </div></div> 
        <span >
           Bot
        </span>
        </div> <div class='message-container'>
        <div class=' bot-message quick-replies-text' id='bot-msg-id'>${value.text}</div></div>` :
        `<div class='message-container'>
        
        <div class='user-message'>
       
        
        
         ${value.text}
       </div>
        <div class="user-caption"><div class="avatar">
  <div data-status="loaded" data-cover="true" class="lazy-img">
  <img src=${props.isMobile == 'true' ? props.profile : props.domElement.getAttribute("data-profile") } alt="" class="lazy-img-loaded">
  </div></div> 
  </div> 
      </div>
    `
      }`
    
     
        
      
    }
    });
      
      
    // return botMsg;

  }

  const multiChoiceAnswer = (text, payload, is_button_click, isLinkClick) => {
    if (isSvg(text)) {
      send(payload, is_button_click, isLinkClick)
    }
    else {
      userMessage(text)
      send(payload, is_button_click, isLinkClick)
    }
  }

  const processResponse = (msg) => {
    var botMsg = '';
    let btnHtml = '';
    var buttonarray = [];
    msg?.map((value, index) => {
      if (value.buttons) {
        buttonarray = value.buttons.length;
      }


      if (value.text !== 'undefined' && buttonarray.length === 0) {
        botMsg += `<div class='message-container' ><div class=' bot-message quick-replies-text' id='bot-msg-id'>${value.text}</div></div><br />`
      }

      if (value.buttons && value.buttons.length > 0) {

        value.buttons.map((btn, i) => {
          let encodedText = btn.payload.replace(/'/g, 'zzz');
          if (btn.title !== 'undefined') {
            if (isSvg(btn.title)) {

              btnHtml += `<button  class="like-button " style="top:5px; bottom:5px"   id="responsiveCard${i}" > ${btn.title}</button>`;
            }
            else {

              btnHtml += `<button  class="single-button " id="responsiveCard${i}" >${btn.title} </button>`;
            }
          }
        });
        if (value.text != '') {
          botMsg += `<div class=" bot-message" id="quick-replies-btn"><div class='quick-replies-text'>${value.text}</div><div  class="quick-replies-buttons">${btnHtml}</div></div>`

        }
        else {
          botMsg += btnHtml;
        }

      }
    });

    removeLoader();
    return botMsg;

  }

  const removeLoader = () => {
    const $chatbotMessages = document.getElementById('chat-output');
    let loadingElem = document.getElementById('is-loading')
    if (loadingElem) $chatbotMessages.removeChild(loadingElem)

  }



  useEffect(() => {
    const interval = setInterval(() => {
      timeDifference();
    }, MINUTE_MS);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, [])

  const timeDifference = () => {
    var currentMessageTime = moment(new Date());
    var lastMessageTime = localStorage.getItem('lastMessageTime');
    var d = moment.duration(currentMessageTime.diff(moment(lastMessageTime)));
    var timeSinceLastMessage = d.asMinutes();
    setTimeDifference(timeSinceLastMessage);
    let msgTime = timeSinceLastMessage < 10 ? true : false;
    return msgTime;
  }

  const generateChatID = () => {

    if (timeDifference()) {
      setChatId(localStorage.getItem('chat_id'));
      if (localStorage.getItem('chat_id') === undefined) {
        const chatID = data.userId + uuidv4();
        localStorage.setItem('chat_id', chatID.toString());
      }

    }
    else {
      const chatID = data.userId + uuidv4();
      // sessionStorage.setItem('chat_id', chatID.toString());
      localStorage.setItem('chat_id', chatID.toString())

    }

  }


  const send = (text, is_button_click, isLinkClick) => {
    var param;
    generateChatID();
    setBotMessage([]);

    localStorage.setItem('lastMessageTime', moment(new Date()));

    if (isLinkClick) {
      param = {
        "conversation_id": localStorage.getItem('chat_id')

      }
      try{
      getChatHistoryResponse((param)).then(res => {
        setLoading(false);
        let botMsg = res?.data;

        console.log('history chat',res,botMsg)
        setchatHistoryMessage(botMsg);
        setHistoryResponse(res?.data)
      });
    }catch(e){console.log('history error', e)}
    }
    else {

      param = {

        "sender": data.sender + localStorage.getItem('chat_id'),
        "text": text,
        "metadata": {
          "is_logged_in": Boolean(props.isloggedin),
          "loan_number": props.loanid,
          "first_name": props.firstname.toUpperCase(),
          "login_status": props.loginstatus,
          "conversation_id": localStorage.getItem('chat_id'),
          "is_button": is_button_click

        }
      }
    

    getChatResponse((param)).then(res => {
      setLoading(false);
      let botMsg = res?.data;
      setBotMessage(botMsg);
      setResponse(res?.data, botLoadingDelay + botReplyDelay)
    });
  
    aiMessage(loader, true, botLoadingDelay)
  }


  };

  const userMessage = (content) => {
    const $chatbotMessages = document.getElementById('chat-output');

    $chatbotMessages.innerHTML += `
    <div class='message-container'>
    
      <div class='user-message'>
     
      
      
       ${content}
     </div>
      <div class="user-caption"><div class="avatar">
<div data-status="loaded" data-cover="true" class="lazy-img">
<img src=${props.isMobile == 'true' ? props.profile : props.domElement.getAttribute("data-profile") } alt="" class="lazy-img-loaded">
</div></div> 
</div> 
    </div>
  `;

  }


  const submit = (event) => {
    event.preventDefault();
    validateMessage(message);
  }

  // const toggleClass= (e)=>{
  //   e.preventDefault();
  //   if(!toggle){
  //   window.parent.postMessage({ type: 'setParentCss', css: 'height: 704px;width:365px' }, 'http://localhost:3000');
  //   }
  //   else{
  //     window.parent.postMessage({ type: 'setParentCss', css: 'height: 200px;width:115px' }, 'http://localhost:3000');

  //   }
  // }





  return (
    <>
      <div id="chat-box-div" className={` ${!toggle ? 'hidden' : "chat-box"}`}>
        <div className="chat-box-header">

          <div data-shadow="true" className="top" >
            <div className="close">
              <div data-size="normal" className="tpl-close" onClick={(e) => {
                e.preventDefault(); setToggle(!toggle);
                console.log('onclick')
              }}>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path className="close-icons-path" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="#385A77"></path>
                </svg>
              </div>
            </div>
            {/* <div className="logo-avatar">
              <div className="tpl-avatar">
                <div className="tpl-avatar-status" style={{ borderColor: "limegreen", background: "limegreen" }}>
                </div> <div className="tpl-avatar-image"><div data-status="loaded" data-cover="true" className="lazy-img">
                  <img src="/chat_bot.png" alt="" className="lazy-img-loaded" /></div></div></div></div> */}
            <div className="company">
              <div className="header" >
                Chatbot
              </div>
              {/* <div className="status" style={{ color: '#385A77', float: 'left' }}>
                Online
              </div> */}
            </div>
          </div>
        </div>
        {/* <span className="chat-box-toggle" onClick={() => { setToggle(!toggle); welcomeMessage() }}><i className="fa fa-close"></i></span></div> */}
        <div className="chat-box-body">
          <div className="chat-box-overlay"></div>
          <div id="chat-logs-msg " className="chat-logs">

            <div className="chat-output" id="chat-output">
              {/* <div className="caption"><div className="avatar">
                <div data-status="loaded" data-cover="true" className="lazy-img">
                  <img src="/chat_bot.png" alt="" className="lazy-img-loaded" />
                </div></div>
                {/* <span style={{ color: 'grey' }}>
                  Bot
                </span> 
              </div> */}

              {/* <div className='message-container'>
                <div className="user-message">

                  

                </div>
              </div> */}

            </div>
          </div>
        </div>
        <div className="input">
          <form onSubmit={(event) => submit(event)}>
            <input
              type="text"
              onChange={handleChange}
              value={message}
              placeholder="Type"
            />
            {/* <div > */}
            {/* { message == '' &&
           <> <button style={{right:'85px'}} className="icons">
            <svg width="25px" height="25px" viewBox="-5.52 -5.52 35.04 35.04" fill="none"  transform="matrix(1, 0, 0, 1, 0, 0)"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path  className="icons-path" d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z" stroke="#2f2d2d" strokeWidth="1.5" strokeLinecap="round" strokeLinecap="round"></path> <path  className="icons-path" d="M18.75 10.5005C18.595 10.0617 18.3077 9.68178 17.9278 9.41305C17.5478 9.14432 17.0939 9.00001 16.6285 9.00001C16.1631 9.00001 15.7092 9.14432 15.3292 9.41305C14.9551 9.67765 14.6709 10.0501 14.5142 10.4803" stroke="#919c94" strokeWidth="1.5" strokeLinecap="round" strokeLinecap="round"></path> <path  className="icons-path" d="M5.25018 10.5005C5.4052 10.0617 5.69247 9.68178 6.07242 9.41305C6.45237 9.14432 6.9063 9.00001 7.37168 9.00001C7.83706 9.00001 8.29099 9.14432 8.67094 9.41305C9.03808 9.67272 9.31868 10.0362 9.47705 10.4563" stroke="#919c94" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> <path  className="icons-path" d="M5.94824 15C6.50681 16.1273 7.3692 17.076 8.43818 17.7394C9.50715 18.4027 10.7402 18.7542 11.9982 18.7542C13.2563 18.7542 14.4893 18.4027 15.5583 17.7394C16.6202 17.0804 17.4782 16.1399 18.0371 15.0224"  stroke="#2f2d2d" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
              </button>
            <button style={{right:'45px'}}  className="icons">
            <svg height="20px" width="20px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 280.067 280.067"  fill="#2f2d2d"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path className="icons-path" d="M149.823,257.142c-31.398,30.698-81.882,30.576-113.105-0.429 c-31.214-30.987-31.337-81.129-0.42-112.308l-0.026-0.018L149.841,31.615l14.203-14.098c23.522-23.356,61.65-23.356,85.172,0 s23.522,61.221,0,84.586l-125.19,123.02l-0.044-0.035c-15.428,14.771-40.018,14.666-55.262-0.394 c-15.244-15.069-15.34-39.361-0.394-54.588l-0.044-0.053l13.94-13.756l69.701-68.843l13.931,13.774l-83.632,82.599 c-7.701,7.596-7.701,19.926,0,27.53s20.188,7.604,27.88,0L235.02,87.987l-0.035-0.026l0.473-0.403 c15.682-15.568,15.682-40.823,0-56.39s-41.094-15.568-56.776,0l-0.42,0.473l-0.026-0.018l-14.194,14.089L50.466,158.485 c-23.522,23.356-23.522,61.221,0,84.577s61.659,23.356,85.163,0l99.375-98.675l14.194-14.089l14.194,14.089l-14.194,14.098 l-99.357,98.675C149.841,257.159,149.823,257.142,149.823,257.142z"></path> </g> </g></svg>
            </button>
            </>} */}


            <button style={{ right: '-5px' }}>
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 500 500"
              >
                <g>
                  <g>
                    <polygon className="polygon-fill" points="0,497.25 535.5,267.75 0,38.25 0,216.75 382.5,267.75 0,318.75" />
                  </g>
                </g>
              </svg>
            </button>
            {/* </div> */}
          </form>
        </div>
      </div>
      <div className={`${toggle ? 'hidden' : ""}`} id="chat-circle" onClick={(e) => { e.preventDefault(); setToggle(!toggle); console.log('onclick') }}>
        <img src="/chat-bot.svg" />
        {/* <div className="chat-container">
          <div className="robot-ears">
            <div className="robot-ear-left"></div>
            <div className="robot-ear-right"></div>
          </div>
          <div className="robot-head">
            <div className="pulse"></div>
            <div className="robot-antenna"></div>
            <div className="robot-face">
              <div className="robot-eye-left"></div>
              <div className="robot-eye-right"></div>
              <svg className="robot-mouth" width="100%" height="100%"
                viewBox="0 0 170 63"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              // xmlns:xlink="http://www.w3.org/1999/xlink" 

              >
                <path d="M10,10c11.985,25.848 41.76,42.886 74.947,42.886c33.188,0 62.962,-17.038 74.947,-42.886c-11.985,25.848 -41.759,42.886 -74.947,42.886c-33.187,0 -62.962,-17.038 -74.947,-42.886Z"
                  style={{ stroke: '#2275BC', strokeWidth: '18px' }} /></svg>
            </div>
          </div>
        </div> */}
      </div>
    </>
  )
}

export default ChatBot;